import React, { useEffect } from "react";
import { useTranslation } from "next-i18next";
import TagManager from "react-gtm-module";
import Header from "./header/Header";
import Footer from "./Footer";
import { useGlobalState } from "../../context/GlobalStateContext";
import { Toaster } from "../ui_components/Toaster";
import { usePathname } from "next/navigation";
import { REQUEST_DEMO } from "helpers/constants/routes";

const Layout = ({ children }) => {
  const { t: content } = useTranslation("layout");
  const { isLoading, toasters, loadGlobalState } = useGlobalState();
  const path = usePathname();

  useEffect(() => {
    const googleTagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
    if (googleTagManagerId) {
      TagManager.initialize({ gtmId: googleTagManagerId });
    }
    loadGlobalState();
  }, []); // [] ensures this runs only once on initial render

  return (
    <>
      {
        !isLoading && !path?.includes(REQUEST_DEMO) && <Header content={content} /> // remove header in markering page
      }
      {toasters.map((toaster, index) => (
        <Toaster
          key={index}
          index={index}
          message={toaster.message}
          type={toaster.type}
          onClose={toaster.callback}
        />
      ))}
      <main>{children}</main>
      {!isLoading && <Footer content={content} />}
    </>
  );
};

export default Layout;
